import React from 'react';
import { TemplateBuilderContainer } from './Components/TemplateBuilderContainer';
import {
  TemplateBuilder,
  TemplateBuilderFactory,
} from './Components/TemplateBuilderFactory';
import { TemplateBuilderInputTriggerSection } from './Components/TemplateBuilderInputTriggerSection';
import { TemplateBuilderReengagementSection } from './Components/TemplateBuilderReengagementSection';
import { TemplateSubsectionLink } from './Components/TemplateSubsectionLink';

export const UltimateWelcomeFunnelBuilder: TemplateBuilder = ({
  maxFollowUpCounts,
}) => (
  <TemplateBuilderFactory
    template="ultimate_welcome_funnel"
    {...maxFollowUpCounts}
  >
    {props => {
      return (
        <TemplateBuilderContainer
          enabled={!props.busy && props.isValid}
          confirm={props.confirm}
        >
          <TemplateBuilderInputTriggerSection>
            <div>
              On {props.channelName}, when someone {props.triggersSelect}, send{' '}
              {props.channelMessageName} to attempt to collect their{' '}
              {props.collectionSelect}, then ask them{' '}
              {props.qualifyingQuestionSelect}.
            </div>
          </TemplateBuilderInputTriggerSection>
          <TemplateSubsectionLink />
          <TemplateBuilderReengagementSection>
            <div>
              Using the data collected from {props.channelName}, if the lead is
              qualified (a Unicorn!) send them a {props.unicornEmailSelect}{' '}
              Email and {props.unicornSMSSelect} SMS text message re-engagement
              sequence. If someone is not qualified (a Donkey) send them a{' '}
              {props.donkeyEmailSelect} Email and {props.donkeySMSSelect} text
              message re-engagement sequence.
            </div>
          </TemplateBuilderReengagementSection>
        </TemplateBuilderContainer>
      );
    }}
  </TemplateBuilderFactory>
);
